import { ReactComponent as Blog } from './assets/icons/Property 1=icon-park_doc-search-two.svg';
import { ReactComponent as VoiceSvg } from './assets/icons/Property 1=iconoir_voice.svg';
import { ReactComponent as BlogGuideline } from './assets/icons/Property 1=Frame 158.svg';
export const sidebarMenu1 = [
  { key: '1', label: 'My Blogs', tooltip: 'List of blogs and drafts', icon: Blog, url: 'my-blog' },
  {
    key: '2',
    label: 'Brand Voice',
    tooltip:
      'Create a brand voice templates, you can select the template you need while creating a blog. it will reflect in your blogs.',
    icon: VoiceSvg,
    url: 'brand-voice'
  },
  {
    key: '3',
    label: 'Blog Guidelines',
    tooltip: 'Create a blog guideline that system will remember.',
    icon: BlogGuideline,
    url: 'blog-guideline'
  },
  {
    key: '4',
    label: 'Blog Auditor',
    tooltip: 'Analyze any blog URL or pasted content — see how rankable it is by ChatGPT, Gemini, and other LLMs.',
    icon: Blog,
    url: 'blog-auditor'
  },
  {
    key: '5',
    label: 'AEO Auditor',
    tooltip: 'Analyze any URL or content and get dual search-readiness scores (AEO & GEO).',
    icon: Blog,
    url: 'aeo-auditor'
  }
  // { key: '5', label: 'Style Guide', icon: StyleGuide, url: 'style-guide' },
  // { key: '6', label: 'AI Model', icon: AI_Model, url: 'ai-model' }
];

export const sidebarMenu2 = [
  // { key: '1', label: 'Guide', icon: Guide, dropdown: false },
  { key: '3', label: 'Account Settings', icon: Blog, dropdown: true }
];

export const modelDropdown = [
  {
    id: 'gemini-3.5-flash',
    value: 'Gemini-3.5 Flash',
    type: 'Basic'
  },
  {
    id: 'gemini-3.1-pro',
    value: 'Gemini-3.1 Pro',
    type: 'Basic'
  },
  {
    id: 'gpt-5',
    value: 'GPT-5',
    type: 'Pro'
  },
  {
    id: 'gpt-5.4-mini',
    value: 'GPT-5.4 Mini',
    type: 'Pro'
  },
  {
    id: 'claude-sonnet-5',
    value: 'Claude Sonnet 5',
    type: 'Pro'
  }
];

export const languagesDropdown = [
  {
    id: 'en',
    value: 'English',
    type: 'Free'
  },
  {
    id: 'zh',
    value: 'Chinese (Traditional)',
    type: 'Pro'
  },
  {
    id: 'zh-HK',
    value: 'Chinese (Simplified)',
    type: 'Pro'
  },
  {
    id: 'es',
    value: 'Spanish',
    type: 'Pro'
  },
  {
    id: 'de',
    value: 'German',
    type: 'Pro'
  }
];

export const plans: { [key: string]: string[] } = {
  Free: ['Free'],
  Basic: ['Free', 'Basic'],
  Pro: ['Free', 'Basic', 'Pro'],
  Agency: ['Free', 'Basic', 'Pro']
};

export const planDetail = [
  {
    id: 1,
    title: 'Basic',
    time: 'monthly',
    planId: process.env.REACT_APP_PLAN_ID_BASIC_MONTHLY,
    price: '4.99',
    billed: 'Billed Monthly',
    discount: '0',
    content: [
      { text: '3 Blog Generations', disabled: false },
      { text: '2 Files / Blog', disabled: false },
      { text: 'Key Word Research', disabled: false },
      { text: '0 Link Crawl / Blog', disabled: true },
      { text: 'Multilingual Support', disabled: true },
      { text: 'AI Image Generation', disabled: true }
    ],
    llm: [
      { text: 'Gemini-3.5-Flash', disabled: false },
      { text: 'Gemini-3.1-Pro', disabled: false }
    ]
  },
  {
    id: 3,
    title: 'Pro',
    time: 'monthly',
    planId: process.env.REACT_APP_PLAN_ID_PRO_MONTHLY,
    price: '11.99',
    billed: 'Billed Monthly',
    discount: '0',
    content: [
      { text: '10 Blog Generations', disabled: false },
      { text: '5 Files / Blog', disabled: false },
      { text: 'Key Word Research', disabled: false },
      { text: '2 Link Crawl / Blog', disabled: false },
      { text: 'Multilingual Support', disabled: false },
      { text: 'AI Image Generation', disabled: true }
    ],
    llm: [
      { text: 'Gemini-3.1-Pro', disabled: false },
      { text: 'Gemini-3.5-Flash', disabled: false },
      { text: 'GPT-5', disabled: false },
      { text: 'GPT-5.4-Mini', disabled: false },
      { text: 'Claude-Sonnet-5', disabled: false }
    ]
  },
  {
    id: 4,
    title: 'Agency',
    price: '24.99',
    time: 'monthly',
    planId: process.env.REACT_APP_PLAN_ID_AGENCY_MONTHLY,
    billed: 'Billed Monthly',
    discount: '10',
    content: [
      { text: '30 Blog Generations', disabled: false },
      { text: '10 Files / Blog', disabled: false },
      { text: 'Key Word Research', disabled: false },
      { text: '5 Link Crawl / Blog', disabled: false },
      { text: 'Multilingual Support', disabled: false },
      { text: 'AI Image Generation', disabled: false }
    ],
    llm: [
      { text: 'Gemini-3.1-Pro', disabled: false },
      { text: 'Gemini-3.5-Flash', disabled: false },
      { text: 'GPT-5', disabled: false },
      { text: 'GPT-5.4-Mini', disabled: false },
      { text: 'Claude-Sonnet-5', disabled: false }
    ]
  },
  {
    id: 5,
    title: 'Basic',
    time: 'yearly',
    planId: process.env.REACT_APP_PLAN_ID_BASIC_YEARLY,
    price: '40.99',
    billed: 'Billed Annually',
    discount: '0',
    content: [
      { text: '3 Blog Generations', disabled: false },
      { text: '2 Files / Blog', disabled: false },
      { text: 'Key Word Research', disabled: false },
      { text: '0 Link Crawl / Blog', disabled: true },
      { text: 'Multilingual Support', disabled: true },
      { text: 'AI Image Generation', disabled: true }
    ],
    llm: [
      { text: 'Gemini-3.5-Flash', disabled: false },
      { text: 'Gemini-3.1-Pro', disabled: false }
    ]
  },
  {
    id: 6,
    title: 'Pro',
    price: '111.99',
    time: 'yearly',
    planId: process.env.REACT_APP_PLAN_ID_PRO_YEARLY,
    billed: 'Billed Annually',
    discount: '10',
    content: [
      { text: '10 Blog Generations', disabled: false },
      { text: '5 Files / Blog', disabled: false },
      { text: 'Key Word Research', disabled: false },
      { text: '2 Link Crawl / Blog', disabled: false },
      { text: 'Multilingual Support', disabled: false },
      { text: 'AI Image Generation', disabled: true }
    ],
    llm: [
      { text: 'Gemini-3.1-Pro', disabled: false },
      { text: 'Gemini-3.5-Flash', disabled: false },
      { text: 'GPT-5', disabled: false },
      { text: 'GPT-5.4-Mini', disabled: false },
      { text: 'Claude-Sonnet-5', disabled: false }
    ]
  },
  {
    id: 7,
    title: 'Agency',
    price: '340.99',
    time: 'yearly',
    planId: process.env.REACT_APP_PLAN_ID_AGENCY_YEARLY,
    billed: 'Billed Annually',
    discount: '10',
    content: [
      { text: '30 Blog Generations', disabled: false },
      { text: '10 Files / Blog', disabled: false },
      { text: 'Key Word Research', disabled: false },
      { text: '5 Link Crawl / Blog', disabled: false },
      { text: 'Multilingual Support', disabled: false },
      { text: 'AI Image Generation', disabled: false }
    ],
    llm: [
      { text: 'Gemini-3.1-Pro', disabled: false },
      { text: 'Gemini-3.5-Flash', disabled: false },
      { text: 'GPT-5', disabled: false },
      { text: 'GPT-5.4-Mini', disabled: false },
      { text: 'Claude-Sonnet-5', disabled: false }
    ]
  }
];
export const planTab = [
  {
    id: 1,
    title: 'Yearly(Save12%)'
  },
  {
    id: 2,
    title: 'Monthly'
  }
];
